var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useNavigate } from 'react-router-dom';
import qs from 'qs';
import { decamelize } from '../utils/camelize';
var previousQueries = {};
var defaultBuildOrder = function (order) { return decamelize(order); };
export default function useFetch(_a) {
    var _this = this;
    var buildFilterParams = _a.buildFilterParams, _b = _a.buildOrder, buildOrder = _b === void 0 ? defaultBuildOrder : _b, api = _a.api, onChange = _a.onChange;
    var navigate = useNavigate();
    var fetch = React.useCallback(function (query) { return __awaiter(_this, void 0, void 0, function () {
        var queryString, previousQuery, order, apiParams, response, data, meta, maxPage, page;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    queryString = qs.stringify({
                        filters: query.filters.reduce(function (result, filter) {
                            if (filter.column && typeof filter.column.field === 'string') {
                                result[filter.column.field] = filter.value;
                            }
                            return result;
                        }, {}),
                        orderBy: (_a = query.orderBy) === null || _a === void 0 ? void 0 : _a.field,
                        orderDirection: query.orderDirection,
                        page: query.page,
                        pageSize: query.pageSize,
                    });
                    previousQuery = previousQueries[location.pathname];
                    if (previousQuery !== queryString) {
                        if (previousQuery)
                            navigate("".concat(location.pathname, "?").concat(queryString));
                        previousQueries[location.pathname] = queryString;
                    }
                    order = query.orderBy && typeof query.orderBy.field === 'string'
                        ? buildOrder(query.orderBy.field)
                        : '';
                    apiParams = {
                        q: buildFilterParams(query),
                        per: query.pageSize,
                        page: query.page + 1,
                        order: buildOrder(order),
                        direction: query.orderDirection,
                    };
                    return [4 /*yield*/, api(apiParams)];
                case 1:
                    response = _b.sent();
                    if (!response)
                        throw Error('fetch error');
                    data = response.data, meta = response.meta;
                    onChange && onChange(data, meta);
                    maxPage = Math.floor((meta.total - 1) / query.pageSize);
                    page = query.page > maxPage ? maxPage : query.page;
                    return [2 /*return*/, { data: data, page: page, totalCount: meta.total }];
            }
        });
    }); }, [api, buildFilterParams, history, onChange, buildOrder]);
    return fetch;
}
